<template>
    <div>
        <div style="margin-bottom: 15px">
            <span>商户名称、申请人或申请人联系方式：</span>
            <a-input v-model="keyword" style="width: 20%" @keypress.enter="handleSearch" />
            <a-button type="primary" style="margin-left: 15px" @click="handleSearch">查询</a-button>
        </div>

        <a-table
                :columns="columns"
                :data-source="rows"
                :pagination="pagination"
                @change="handleTableChange"
                bordered>
            <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
            <template slot="action" slot-scope="text, record">
                <a-button type="link" @click="$refs.checkForm.showForm(record)">审批</a-button>
            </template>
        </a-table>
        <check-form ref="checkForm" @accept="handleAccept"></check-form>
    </div>
</template>

<script>
    import vendorService from '@/service/vendor'
    import OwnerView from "../VendorList/~OwnerView";
    import Icon from "ant-design-vue/es/icon";
    import CheckForm from "./CheckForm";

    export default {
        name: "VendorCheck",
        components: { OwnerView, CheckForm},
        data() {
            return {
                columns: [
                    {title: '#', width: "5%", scopedSlots: { customRender: 'serial' }},
                    {title: '申请人',width: "8%", dataIndex: 'owner_name', },
                    {title: '申请人联系方式',width: "12%", dataIndex: 'owner_phone', },
                    {title: '商户名称',width: "10%", dataIndex: 'vendor_name',},
                    {title: '商户地址',width: "15%", dataIndex: 'address', },
                    {title: '操作',width: "7%", dataIndex: 'action', scopedSlots: {customRender: 'action'}}
                ],
                rows: [],
                pagination: {},
                keyword: ''
            };
        },
        mounted() {
            let params = {
                pageNo: 1,
                pageSize: 5,
            }
            this.fetch(params)
        },
        methods: {
            handleTableChange(pagination) {
                let pager = {
                    pageNo: pagination.current,
                    pageSize: pagination.pageSize,
                    keyword: this.keyword
                }
                this.fetch(pager)
            },
            handleSearch() {
                this.fetch({
                    pageNo: 1,
                    pageSize: 5,
                    keyword: this.keyword,
                })
            },
            fetch(params) {
                vendorService.getCheckList( params).then((res) => {
                    const pagination = { ...this.pagination };
                    this.rows = res.data.records
                    pagination.current = res.data.current
                    pagination.total = res.data.total
                    pagination.pageSize = res.data.size
                    pagination.showTotal = (total, range) => {
                        return `${range[0]}-${range[1]} of ${total} items`
                    }
                    this.pagination = pagination
                });
            },

            handleAccept(values) {
                console.log("values", values)
                vendorService.accept( values).then((res) => {
                    if(res.data.success) {
                        this.$notification.open({
                            message: '成功！',
                            description: res.data.message,
                        });
                        let params = {
                            pageNo: 1,
                            pageSize: 5,
                        }
                        this.fetch(params)
                    } else {
                        this.$notification.open({
                            message: '失败！',
                            description: res.data.message,
                            icon: (h) => {
                                return h(Icon, {
                                    attrs: {type: 'close-circle', style: 'color: red'}
                                });
                            }
                        });
                    }
                })
            }
        }
    }
</script>
